var map = {
	"./template.bet777": 1026,
	"./template.bet777.tsx": 1026,
	"./template.betprofessor": 1027,
	"./template.betprofessor.tsx": 1027,
	"./template.betroyale": 1028,
	"./template.betroyale.tsx": 1028,
	"./template.buffalobet": 1029,
	"./template.buffalobet.tsx": 1029,
	"./template.default": 650,
	"./template.default.tsx": 650,
	"./template.fiestabet": 1030,
	"./template.fiestabet.tsx": 1030,
	"./template.forsport": 1031,
	"./template.forsport.tsx": 1031,
	"./template.goldenrush": 1032,
	"./template.goldenrush.tsx": 1032,
	"./template.oldgill": 1033,
	"./template.oldgill.tsx": 1033,
	"./template.puntcity": 1034,
	"./template.puntcity.tsx": 1034,
	"./template.puntgenie": 1035,
	"./template.puntgenie.tsx": 1035,
	"./template.questbet": 1036,
	"./template.questbet.tsx": 1036,
	"./template.ts": 960,
	"./template.volcanobet": 1037,
	"./template.volcanobet.tsx": 1037,
	"./template.wellbet": 1038,
	"./template.wellbet.tsx": 1038
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2324;